import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Work from "./components/Work";
import About from "./components/About";
import Capabilities from "./components/Capabilities";
import Experience from "./components/Experience";
import Credentials from "./components/Credentials";
import Principles from "./components/Principles";
import AppliedAI from "./components/AppliedAI";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function useReveal() {
  useEffect(() => {
    const nodes = document.querySelectorAll(".reveal");
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      nodes.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    document.documentElement.classList.add("motion-ready");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );

    nodes.forEach((el) => observer.observe(el));

    // Failsafe: never leave content hidden if IO never fires.
    const failsafe = window.setTimeout(() => {
      nodes.forEach((el) => el.classList.add("is-visible"));
    }, 2500);

    return () => {
      window.clearTimeout(failsafe);
      observer.disconnect();
      document.documentElement.classList.remove("motion-ready");
    };
  }, []);
}

export default function App() {
  useReveal();
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = navOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [navOpen]);

  return (
    <div className="min-h-screen bg-canvas text-ink">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-ink focus:px-4 focus:py-2 focus:text-canvas"
      >
        Skip to content
      </a>
      <Header navOpen={navOpen} setNavOpen={setNavOpen} />
      <main id="main">
        <Hero />
        <Work />
        <About />
        <Capabilities />
        <Experience />
        <Credentials />
        <Principles />
        <AppliedAI />
        <Education />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
